export const POPUP_TYPES = {
  ANALYTICS: "ANALYTICS",
  CHANGELOG: "CHANGELOG",
};
